import * as React from "react";
import "./checkbox.scss";

interface CheckboxProps {
  onChange: () => void;
  inputId: string;
  className?: string;
  checked?: boolean;
  size?: "sm" | "lg";
}

const checkboxDefaultProps: Pick<CheckboxProps, "checked"> = {
  checked: false
};
export const Checkbox: React.FC<CheckboxProps> = ({ className, checked, onChange, children, inputId, size }) => {
  const checkboxSize = size || "lg";
  const checkboxId = `checkbox-input-${inputId}`;

  return (
    <div className={`c-new-checkbox c-new-checkbox--${checkboxSize} ${className ? ` ${className}` : ""}`}>
      <label className="c-new-checkbox__tick">
        <input
          id={checkboxId}
          type="checkbox"
          checked={checked}
          className="c-new-checkbox__input"
          onChange={onChange}
          data-size={checkboxSize}
        />
        <span className="c-new-checkbox__tick-box rectangular" />
      </label>
      <label htmlFor={checkboxId} className="c-new-checkbox__label">
        {children}
      </label>
    </div>
  );
};
Checkbox.defaultProps = checkboxDefaultProps;
